import EcomPasetoAjax from '@square/dashboard-utilities/services/ecom-paseto-ajax';
export default class WebsiteAjax extends EcomPasetoAjax {}